<div>
  <div class="form-div reviewing-account-div">
    <div class="correct-div"><i class="bi bi-check-circle-fill"></i></div>
    <h2 i18n>Reviewing your Account</h2>
    <p i18n>Thank you for submitting your request. We are currently reviewing your request and will get back to you soon.</p>
  </div>
</div>
